import { defineMessages } from 'react-intl';

export default defineMessages({
    AddressLabel: {
        id: 'cep.components.sgSphRenewalSummary.AddressLabel',
        defaultMessage: 'Insured address:'
    },
    BuildingsLabel: {
        id: 'cep.components.sgSphRenewalSummary.BuildingsLabel',
        defaultMessage: 'Building cover level:'
    },
    ContentsLabel: {
        id: 'cep.components.sgSphRenewalSummary.ContentsLabel',
        defaultMessage: 'Contents cover level:'
    },
    CSDLabel: {
        id: 'cep.components.sgSphRenewalSummary.CSDLabel',
        defaultMessage: 'Start of cover:'
    },
    RenewalDateLabel: {
        id: 'cep.components.sgSphRenewalSummary.RenewalDataLabel',
        defaultMessage: 'Renewal date:'
    },
    CoverYearLabel: {
        id: 'cep.components.sgSphRenewalSummary.CoverYearLabel',
        defaultMessage: 'Cover year:'
    },
    CoverYearInfo: {
        id: 'cep.components.sgSphRenewalSummary.CoverYearInfo',
        defaultMessage: '{startDate} - {endDate}'
    },
});
